/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFormat } from '../../factoriesAny.js';
export var formatDependencies = {
  typedDependencies,
  createFormat
};